import { render } from "./CreateWebsiteNews.vue?vue&type=template&id=734e6aa1&scoped=true"
import script from "./CreateWebsiteNews.vue?vue&type=script&lang=js"
export * from "./CreateWebsiteNews.vue?vue&type=script&lang=js"

import "./CreateWebsiteNews.vue?vue&type=style&index=0&id=734e6aa1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734e6aa1"]])

export default __exports__